import { Component, Input, OnInit } from '@angular/core';
import {LanguageService} from "../../service/language/language.service";

interface INote {
  key: string;
  text: string[];
  whenLastUpdated: string;
  xId: string;
}

@Component({
  selector: 'note',
  template: `
      <div class="note" *ngFor="let note of notes;">
        {{note.whenLastUpdated | date:'shortDate':locale}} {{note.xId}} 
        <div class="text" *ngFor="let text of note.text;">
          {{text}}
        </div>
      </div>
  `,
  styles: [
  ]
})
export class NoteComponent implements OnInit {
  @Input() notes: INote[];
  public locale: string = 'fr';

  constructor(private languageService: LanguageService) {
    this.locale = this.languageService.getUserLanguage();
  }

  ngOnInit(): void {
  }

}
